const initialState = {};

// eslint-disable-next-line default-param-last
const railsPropsReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default railsPropsReducer;
